import { Directive, ElementRef, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[appKeyPress]'
})
export class KeyPressDirective {

  constructor(private el: ElementRef) { }


  @HostListener('keypress', ['$event']) onKeyPress(event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      this.el.nativeElement.click();
    }
  }

}
